import React from 'react';
import { Nullable } from 'global';
import { Typography } from '@mui/material';
import { dealTypeToLabel } from '../../../constants';

interface Props {
  type: Nullable<string>;
}

export const DealTypeCell = ({ type }: Props) => {
  if (!type) return '-';

  return (
    <Typography align="center" component="span" variant="body2">
      {dealTypeToLabel[type] ?? type}
    </Typography>
  );
};
